import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEmploymentDetailsPage = {
  alert: {
    error: 'coapplicant-employment-details-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-employment-details-page.footer.root',
  },
  form: {
    employerNameInput:
      'coapplicant-employment-details-page.form.employer-name-input',
    employerNameInputError:
      'coapplicant-employment-details-page.form.employer-name-input-error',
    grossAnnualIncomeInput:
      'coapplicant-employment-details-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'coapplicant-employment-details-page.form.gross-annual-income-input-error',
    h1: 'coapplicant-employment-details-page.form.h1',
    h2: 'coapplicant-employment-details-page.form.h2',
    jobTitleInput: 'coapplicant-employment-details-page.form.job-title-input',
    jobTitleInputError:
      'coapplicant-employment-details-page.form.job-title-input-error',
    root: 'coapplicant-employment-details-page.form.root',
    submitButton: 'coapplicant-employment-details-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
